export default __webpack_public_path__ + "static/media/old-hostel.967af004.jpg";